// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-product-overview .fixed .slide-in-wrapper {\n  top: 80px;\n  box-shadow: -4px 0px 10px rgba(0,0,0,0.25);\n  height: calc(100vh - 80px);\n}\n.booking-product-overview .fixed .slide-in-wrapper .slide-in-panel {\n  width: 440px;\n  color: #121d32;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
